import React, { useState, useEffect } from "react"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import { InputText } from "primereact/inputtext"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { getTimeAgo, formatPhoneNumber } from "../Utils"
import { Checkbox } from "primereact/checkbox"
import { Button } from "primereact/button"

export default function InvalidMessageLeftConvList({
  convList,
  selectConv,
  selectStandaloneConv,
  selectedConvs,
  showMessageReply,
  refreshConvs
}) {

  const [filteredConvList, setFilteredConvList] = useState(convList)
  const [searchTerm, setSearchTerm] = useState("")
  const [showSearch, setShowSearch] = useState(false)
  const [unreadFilter, setUnreadFilter] = useState(false)

  useEffect(() => {
    if (convList) {
      let updatedFilteredConvList = convList.filter(
        (s) =>
          searchTerm === "" || s.from.toLowerCase().includes(searchTerm.toLowerCase())
      )
      setFilteredConvList(updatedFilteredConvList)
    }
  }, [convList])

  const search = (sTerm) => {
    setSearchTerm(sTerm)
    setFilteredConvList(
      convList.filter(
        (s) =>
          sTerm === "" || s.from.toLowerCase().includes(sTerm.toLowerCase())
      )
    )
  }

  const stopCheckboxPropagation = (e) => {
    e.stopPropagation()
  }

  const isConvSelected = (conv) => {
    return selectedConvs.some(c => c.id === conv.id)
  }

  if (convList.length > 0) {
    return (
      <div className={styles.conversations_menu} style={{ backgroundColor: "#e7e0f180", paddingRight: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: "44px", marginBottom: "30px" }}>
          {!showSearch &&
            <Button
              className={gMessages.searchBtn}
              icon="pi pi-search"
              onClick={() => setShowSearch(true)} />
          }
          {!showSearch &&
            <Button className={gMessages.searchBtn} icon="pi pi-refresh" onClick={() => refreshConvs()}> </Button>
          }
          {showSearch &&
            <span className="p-input-icon-left" style={{ width: "100%" }} >
              <i className="pi pi-search" />
              <InputText
                className={gMessages.searchInput}
                value={searchTerm}
                onChange={(e) => search(e.target.value)}
                placeholder="Search"
              />
              <Button
                className={`custom_button_icon ${gMessages.closeBtn}`}
                icon="pi pi-times"
                onClick={() => {
                  setShowSearch(false)
                  setSearchTerm("")
                  setFilteredConvList(convList)
                }} />
            </span>
          }
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ color: "#383838", fontSize: "16px", fontWeight: "700" }}>Recents</h3>
          <div className={gMessages.checkbox_unread}>
            <Checkbox
              inputId="unreadFilter"
              onChange={e => {
                setUnreadFilter(e.checked)
                setFilteredConvList(
                  convList.filter(
                    (s) =>
                      e.checked ? s.anyUnread : true
                  )
                )
              }}
              checked={unreadFilter}
            />
            <label style={{ color: "#383838", fontSize: "14px" }} htmlFor="unreadFilter">Unread</label>
          </div>
        </div>
        {filteredConvList.length === 0 &&
          <h3
            style={{
              marginTop: "20px",
              textAlign: "center",
              color: "#383838",
              fontSize: "20px"
            }}>No messages</h3>
        }
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", height: "90%" }}>
          <ul className={`${gMessages.chatConvListContainer} ${gMessages.myScrollbar}`} style={{ height: "765px" }}>
            {filteredConvList &&
              filteredConvList.map((conv) => (
                <li
                  key={conv.from}
                  style={{ width: "100%", position: "relative" }}
                  onClick={(e) => {
                    selectStandaloneConv(conv)
                  }}
                >
                  <div
                    className={`${gMessages.convElement} ${isConvSelected(conv) && gMessages.selected}`}
                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    <span onClick={stopCheckboxPropagation}>
                      <Checkbox
                        inputId={`${conv.from}_selected`}
                        name="conv_selected"
                        className={`${gMessages.checkbox_design} ${gMessages.checkbox_border}`}
                        value={isConvSelected(conv)}
                        onChange={(e) => {
                          selectConv(conv)
                        }}
                        checked={isConvSelected(conv)}
                      />
                    </span>
                    
                    <div>
                      <p style={isConvSelected(conv) ? { fontWeight: "600" } : {}}>{formatPhoneNumber(conv.from)}</p>
                      <p className={gMessages.timeAgo}>{getTimeAgo(conv.lastSentAt)}</p>
                    </div>
                  </div>
                  {conv.unread && <span className={gMessages.unread}></span>}
                </li>
              ))}
          </ul>
          <div style={{ margin: "0px", display: "flex", justifyContent: "center" }}>
            <Button
              disabled={selectedConvs.length === 0}
              className={gMessages.inverted_button}
              style={{ width: "80% !important" }}
              label="Reply to all (selected)"
              onClick={showMessageReply}
            />
          </div>
        </div>

      </div >
    )
  }

  return <div className={styles.conversations_menu} style={{ backgroundColor: "#e7e0f180" }}></div>

}
